import * as zod from 'zod';

export const FTPServerConfiguration = zod.object({
  kind: zod.literal('FTPServer'),
  id: zod.string().optional(),
  name: zod.string().default('FTP Server'),
  connectionOptions: zod
    .object({
      host: zod.string().default('localhost'),
      port: zod.number().default(21),
      username: zod.string().default('ftp'),
      password: zod.string().default(''),
      timeout: zod.number().default(30000), // 30 seconds
    })
    .default({}),
  basePath: zod.string().default('/'),
});

export type FTPServerConfiguration = zod.infer<typeof FTPServerConfiguration>;
